var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1186 16.8814L22.75 14.5128V11.375C22.7473 9.20661 21.9406 7.11624 20.4861 5.50811C19.0315 3.89998 17.0322 2.88832 14.875 2.66875V0.875H13.125V2.66875C10.9678 2.88832 8.96854 3.89998 7.51395 5.50811C6.05936 7.11624 5.25271 9.20661 5.25 11.375V14.5128L2.88137 16.8814C2.71727 17.0454 2.62505 17.268 2.625 17.5V20.125C2.625 20.3571 2.71719 20.5796 2.88128 20.7437C3.04538 20.9078 3.26794 21 3.5 21H9.625V21.6799C9.60597 22.7899 9.99723 23.868 10.7238 24.7074C11.4504 25.5469 12.4612 26.0887 13.5625 26.229C14.1708 26.2893 14.785 26.2217 15.3655 26.0304C15.9461 25.8391 16.4802 25.5284 16.9335 25.1183C17.3867 24.7082 17.7492 24.2078 17.9974 23.6492C18.2457 23.0906 18.3743 22.4863 18.375 21.875V21H24.5C24.7321 21 24.9546 20.9078 25.1187 20.7437C25.2828 20.5796 25.375 20.3571 25.375 20.125V17.5C25.375 17.268 25.2827 17.0454 25.1186 16.8814ZM16.625 21.875C16.625 22.5712 16.3484 23.2389 15.8562 23.7312C15.3639 24.2234 14.6962 24.5 14 24.5C13.3038 24.5 12.6361 24.2234 12.1438 23.7312C11.6516 23.2389 11.375 22.5712 11.375 21.875V21H16.625V21.875ZM23.625 19.25H4.375V17.8623L6.74362 15.4936C6.90773 15.3296 6.99995 15.107 7 14.875V11.375C7 9.51849 7.7375 7.73801 9.05025 6.42525C10.363 5.1125 12.1435 4.375 14 4.375C15.8565 4.375 17.637 5.1125 18.9497 6.42525C20.2625 7.73801 21 9.51849 21 11.375V14.875C21 15.107 21.0923 15.3296 21.2564 15.4936L23.625 17.8623V19.25Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2131,
    cy: 5.16232,
    r: 5.1619,
    transform: "rotate(180 20.2131 5.16232)",
    fill: "#EA2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNotification);
export default __webpack_public_path__ + "static/media/dashboard_notification.bc4d69586972223932fbc9ab1f5602df.svg";
export { ForwardRef as ReactComponent };